// SakthiGaneshPage.jsx
// Tailwind CSS with improved colorful UI
import image1 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-0.jpg";
import image2 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-1.jpg";
import image3 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-2.jpg";
import image4 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-3.jpg";
import image5 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-4.jpg";
import image6 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-5.jpg";
import image7 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-6.jpg";
import image8 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-7.jpg";
import image9 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-8.jpg";
import image10 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-9.jpg";
import image11 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-10.jpg";
import image12 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-11.jpg";
import image13 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-12.jpg";
import image14 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-13.jpg";
import image15 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-14.jpg";
import image16 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-15.jpg";
import image17 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-16.jpg";
import image18 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-17.jpg";
import image19 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-18.jpg";
import image20 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-19.jpg";
import image21 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-20.jpg";
import image22 from "../assets/SGTPL TEASER/44b47df2-7f80-4a79-a8f6-6f7758474b7a-21.jpg";
import fab1 from "../assets/pdf/Fabric collection - V1.pdf";
import fab2 from "../assets/pdf/Fabric collection - V2.pdf";
import hero from "../assets/hero.jpg";
import company1 from "../assets/company.webp";

import React, { useState, useEffect } from "react";
import API_URL from "../config";

/////////////////// photo gallery /////////////////
import photo1 from "../assets/image/image1.jpeg";
import photo2 from "../assets/image/image2.jpeg";
import photo3 from "../assets/image/image3.jpeg";
import photo4 from "../assets/image/image4.jpeg";
import photo5 from "../assets/image/image5.jpeg";
import photo6 from "../assets/image/image6.jpeg";
import photo7 from "../assets/image/image7.jpeg";
import photo8 from "../assets/image/image8.jpeg";

///////////////////// pdf  ///////////
import eAuctionProcessDoc from "../assets/pdf/E-auction_Process_Document- Lot-1,2,3,4,5.pdf";
import auctionSaleNotice from "../assets/pdf/Auction Sale Notice - 04th - IBBI.pdf";

import { FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";

// Fallback local attachments
const localAttachments = [
  {
    title: "E-Auction",
    subtitle: "E-Auction Process Document",
    files: [
      { name: "E-auction_Process_Document- Lot-1,2,3,4,5.pdf", url: eAuctionProcessDoc, icon: "📑" },
    ],
  },
  {
    title: "Auction Notice",
    subtitle: "Auction Sale Notice - IBBI",
    files: [
      { name: "Auction Sale Notice - 05th - IBBI.pdf", url: auctionSaleNotice, icon: "📢" },
    ],
  },
  {
    title: "Assets Photos",
    subtitle: "Factory Photos",
    files: [
      { name: "Photo 1", url: photo1, icon: "📷", type: "image" },
      { name: "Photo 2", url: photo2, icon: "📷", type: "image" },
      { name: "Photo 3", url: photo3, icon: "📷", type: "image" },
      { name: "Photo 4", url: photo4, icon: "📷", type: "image" },
      { name: "Photo 5", url: photo5, icon: "📷", type: "image" },
      { name: "Photo 6", url: photo6, icon: "📷", type: "image" },
      { name: "Photo 7", url: photo7, icon: "📷", type: "image" },
      { name: "Photo 8", url: photo8, icon: "📷", type: "image" },
      { name: "Fabric collection - V1.pdf", url: fab1, icon: "📑", type: "pdf" },
      { name: "Fabric collection - V2.pdf", url: fab2, icon: "📑", type: "pdf" },
    ],
  },
];

const buildAttachments = (apiAttachments) => {
  if (!apiAttachments) return localAttachments;

  const sections = [];

  const apiEAuction = apiAttachments.eAuction || [];
  const eAuctionFiles = apiEAuction.length > 0
    ? apiEAuction.map(f => ({ name: f.name, url: f.url, icon: "📑" }))
    : localAttachments[0].files;
  sections.push({ title: "E-Auction", subtitle: "E-Auction Process Document", files: eAuctionFiles });

  const apiOrders = apiAttachments.orders || [];
  const orderFiles = apiOrders.length > 0
    ? apiOrders.map(f => ({ name: f.name, url: f.url, icon: "📢" }))
    : localAttachments[1].files;
  sections.push({ title: "Auction Notice", subtitle: "Auction Sale Notice - IBBI", files: orderFiles });

  const apiPhotos = apiAttachments.assetsPhotos || [];
  const photoFiles = apiPhotos.length > 0
    ? apiPhotos.map(f => ({ name: f.name, url: f.url, icon: "📷", type: "image" }))
    : localAttachments[2].files;
  sections.push({ title: "Assets Photos", subtitle: "Factory Photos", files: photoFiles });

  return sections;
};

const DropdownList = ({ data }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const toggleDropdown = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl h-[600px] overflow-y-auto">
        {data.map((section, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-xl border p-4 flex flex-col transition-all duration-300"
            style={{
              minHeight: openIndex === index ? "auto" : "80px",
              height: openIndex === index ? "auto" : "80px",
            }}
          >
            <div
              className="flex justify-between items-start cursor-pointer gap-3"
              onClick={() => toggleDropdown(index)}
            >
              <div className="flex-1 min-w-0 pr-2">
                <h3 className="font-semibold text-gray-800">{section.title}</h3>
                {section.subtitle && (
                  <p className="text-sm text-gray-500 mt-1">{section.subtitle}</p>
                )}
              </div>
              <div className="flex-shrink-0 mt-1">
                {openIndex === index ? (
                  <FaChevronUp className="text-indigo-600" />
                ) : (
                  <FaChevronDown className="text-indigo-600" />
                )}
              </div>
            </div>

            {openIndex === index && (
              <ul className="mt-3 space-y-2 overflow-y-auto flex-1 pr-1">
                {section.files.map((file, i) => (
                  <li key={i}>
                    {file.type === "image" ? (
                      <div
                        className="flex items-center space-x-2 cursor-pointer"
                        onClick={() => setFullscreenImage(file.url)}
                      >
                        <span>{file.icon}</span>
                        <span>{file.name}</span>
                      </div>
                    ) : (
                      <a
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center space-x-2 text-gray-700 hover:text-indigo-600"
                      >
                        <span>{file.icon}</span>
                        <span>{file.name}</span>
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      {fullscreenImage && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
          <button
            className="absolute top-6 right-6 text-white text-3xl hover:text-gray-300"
            onClick={() => setFullscreenImage(null)}
          >
            <FaTimes />
          </button>
          <img
            src={fullscreenImage}
            alt="Preview"
            className="max-w-5xl max-h-[90%] rounded-lg shadow-lg"
          />
        </div>
      )}
    </>
  );
};

const Hero = ({ company }) => (
  <header className="relative h-120 w-full overflow-hidden shadow-lg">
    <img
      src={company.companyPicture || hero}
      alt="Sakthi Ganesh Textiles"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-indigo-black to-purple-gray" />
    <div className="absolute bottom-10 left-10 text-white">
      <h1 className="text-4xl font-extrabold drop-shadow-lg tracking-wide">
        {company.companyName}
      </h1>
      <p
        className="text-md max-w-xl mt-2 text-white font-medium"
        style={{ textShadow: "1px 1px 3px rgba(0,0,0,0.8)" }}
      >
        {company.address}
      </p>
    </div>
  </header>
);

const CompanyInfo = ({ company }) => (
  <section className="flex flex-col md:flex-row gap-6 p-6 bg-gradient-to-br from-white to-indigo-50 rounded-xl shadow">
    <div className="flex-1 rounded-xl border bg-white p-6 shadow-md hover:shadow-lg transition">
      <h2 className="font-bold mb-3 text-xl text-indigo-700">Company Profile</h2>
      <p className="text-sm leading-relaxed whitespace-pre-line text-gray-700">
        {company.companyProfile}
      </p>
      <div className="mt-4">
        <h3 className="font-semibold text-purple-700">Liquidation / Legal</h3>
        <p className="text-sm mt-1 text-gray-600">{company.liquidOrder}</p>
        <p className="text-sm mt-2 whitespace-pre-line text-gray-600">
          {company.liquidator}
        </p>
      </div>
    </div>

    <aside className="w-full md:w-80 rounded-xl border p-5 bg-white shadow-md">
      <h2 className="font-bold mb-3 text-indigo-700">Quick Info</h2>
      <div className="text-sm space-y-2 text-gray-700">
        <p><strong>Name:</strong> {company.quickInfo?.name || company.companyName}</p>
        <p><strong>Address:</strong> {company.quickInfo?.address || company.address}</p>
        <p><strong>CIN:</strong> {company.quickInfo?.cin || company.cin}</p>
      </div>
      <img
        src={company.quickInfo?.picture || company1}
        alt="thumbnail"
        className="mt-4 h-44 w-full object-cover rounded-lg shadow"
      />
    </aside>
  </section>
);

const Slide = ({ apiSliderImages }) => {
  const localImages = [
    image1, image2, image3, image4, image5, image6, image7, image8, image9, image10,
    image11, image12, image13, image14, image15, image16, image17, image18, image19, image20,
    image21, image22,
  ];

  const images = (apiSliderImages && apiSliderImages.length > 0)
    ? apiSliderImages.map(img => img.url)
    : localImages;

  const partnerOverlayBySlide = {
    0: {
      title: "Meet Our Partners",
      names: [
        "CA. S. Prabhu, FCA, FAFD, IP",
        "CA. M. Suresh Kumar, FCA, RV (S&FA), IP",
        "CA. P. Prakash, FCA, RV (S&FA)",
        "CA. S Sidharth, ACA, PGIP",
      ],
    },
  };

  const [index, setIndex] = useState(0);

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="h-[800px] m-6 p-5 rounded-2xl overflow-hidden relative shadow-xl bg-white">
      <div className="relative h-full w-full">
        <img
          src={images[index]}
          alt="carousel"
          className="h-[100%] w-full object-contain transition-all duration-700"
        />
        {partnerOverlayBySlide[index] && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none px-4">
            <div className="bg-black/60 text-white p-5 rounded-lg text-center max-w-3xl">
              <h3 className="text-2xl font-bold mb-3">
                {partnerOverlayBySlide[index].title}
              </h3>
              {partnerOverlayBySlide[index].names.map((name) => (
                <p key={name} className="text-sm md:text-base leading-relaxed">
                  {name}
                </p>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/50 text-white px-4 py-1 rounded-full text-sm font-medium shadow-lg">
        {index + 1} / {images.length}
      </div>
      <button
        onClick={prevSlide}
        className="absolute top-1/2 left-6 -translate-y-1/2 bg-gradient-to-r from-purple-500 to-indigo-600 text-white p-3 rounded-full shadow-lg hover:scale-110 hover:shadow-2xl transition-transform"
      >
        <span className="text-2xl font-bold">&#8249;</span>
      </button>
      <button
        onClick={nextSlide}
        className="absolute top-1/2 right-6 -translate-y-1/2 bg-gradient-to-r from-indigo-600 to-purple-500 text-white p-3 rounded-full shadow-lg hover:scale-110 hover:shadow-2xl transition-transform"
      >
        <span className="text-2xl font-bold">&#8250;</span>
      </button>
    </div>
  );
};

const WhoWeAre = ({ whoWeAre }) => (
  <section className="px-6 py-12 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl">
    <h3 className="text-3xl font-bold mb-8 text-center text-indigo-700">Who We Are</h3>
    <div className="p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition text-gray-700 space-y-4 leading-relaxed">
      {whoWeAre?.description ? (
        <div 
          className="description-content"
          dangerouslySetInnerHTML={{ __html: whoWeAre.description }} 
        />
      ) : (
        <p className="text-gray-400 italic">No description available.</p>
      )}
      
      <div className="mt-8 pt-6 border-t border-indigo-100 grid grid-cols-1 md:grid-cols-2 gap-6">
        {whoWeAre?.email && (
          <div>
            <h4 className="font-bold text-indigo-700 text-sm uppercase tracking-wider mb-1">Email</h4>
            <a href={`mailto:${whoWeAre.email}`} className="text-indigo-600 hover:text-indigo-800 transition underline decoration-2 underline-offset-4">
              {whoWeAre.email}
            </a>
          </div>
        )}
        {whoWeAre?.phone && (
          <div>
            <h4 className="font-bold text-indigo-700 text-sm uppercase tracking-wider mb-1">Phone</h4>
            <p className="text-gray-800 font-medium">{whoWeAre.phone}</p>
          </div>
        )}
      </div>
    </div>
  </section>
);

const VideoSection = ({ videoUrl }) => {
  if (!videoUrl) return null;

  const ytMatch = videoUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (ytMatch) {
    return (
      <div className="relative w-full" style={{ paddingBottom: "56.25%", height: 0 }}>
        <iframe
          className="absolute inset-0 w-full h-full"
          src={`https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1&mute=1&loop=1&playlist=${ytMatch[1]}`}
          title="Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="relative w-full h-screen overflow-hidden">
      <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover">
        <source src={videoUrl} type="video/mp4" />
      </video>
    </div>
  );
};

const Footer = ({ company }) => (
  <footer className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-4 text-center text-sm text-white rounded-t-xl">
    Registered Office: {company.address} &bull; Contact: {company.whoWeAre?.phone || "73730-52341 / 94888-10404"}
  </footer>
);

export default function SakthiGaneshPage() {
  const [caseData, setCaseData] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/insolvency-cases/sakthiganesh`)
      .then(res => res.ok ? res.json() : null)
      .then(data => { if (data) setCaseData(data); })
      .catch(err => console.error("Error fetching Sakthi Ganesh data:", err));
  }, []);

  const company = caseData || {
    companyName: "SAKTHI GANESH TEXTILES PRIVATE LIMITED",
    cin: "U17111TZ1996PTC007019",
    address: "Coimbatore, Tamil Nadu",
    companyProfile: "Sakthi Ganesh Textiles Private Limited was incorporated on December 8, 1996.",
    liquidOrder: "Under Interim Resolution Professional (IRP)",
    liquidator: "PAN: AAFCS2211M\nGST Number: 33AAFCS2211M1ZK",
    quickInfo: {},
    whoWeAre: { description: "", email: "", phone: "73730-52341 / 94888-10404" },
    attachments: {},
    sliderImages: [],
    videoUrl: "",
  };

  const attachmentData = buildAttachments(company.attachments);

  return (
    <div className="w-full min-h-screen bg-gray-100 space-y-8">
      <Hero company={company} />
      <div className="px-6 py-3 font-semibold bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded shadow-md">
        CIN: {company.cin}
      </div>
      <CompanyInfo company={company} />
      <VideoSection videoUrl={company.videoUrl} />
      <Slide apiSliderImages={company.sliderImages} />
      <WhoWeAre whoWeAre={company.whoWeAre} />
      <div className="px-6">
        <h3 className="text-3xl font-bold mb-8 text-center text-indigo-700">Attachments</h3>
        <DropdownList data={attachmentData} />
      </div>
      <Footer company={company} />
    </div>
  );
}
